export default function allFilters(filters) {
    return (item) => {
        return filters.reduce((acc, filter) => {
            return acc && (filter ? filter(item) : acc);
        }, true);
    };
}
